import logo from './logo.svg';
import './App.css';
import {BrowserRouter as Router ,Routes,Link,Route, BrowserRouter,} 
from 'react-router-dom';
import './Home.css';
import './box.css';
import Home from './Home';
import About from './About';
import Contact from './Contact';
import Payment from './payment';

function App() {
  return (
    <div>
      <Router>
      <ul>
     
        </ul>
       
        <Routes>
          <Route exact path='/' element={<Home/>}/>
          <Route  path='/About' element={<About/>}/>
          <Route  path='/Contact' element={<Contact/>}/>
          <Route  path='/Payment' element={<Payment/>}/>
          </Routes>
          
       </Router>
       
        </div>
  );
}

export default App;
